import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Video, MessageCircle, Mail, ArrowRight } from "lucide-react";
import { SiteHeader, SiteFooter } from "../components/SiteLayout";
import { buildWaUrl, openWhatsApp, WA_MSG } from "../lib/whatsapp";
import SEO from "../components/SEO";

const CALENDLY_URL = process.env.REACT_APP_CALENDLY_URL || "https://calendly.com/fmsubastasinvestment/30min";

export default function OrientacionReservar() {
  const [calendlyLoaded, setCalendlyLoaded] = useState(false);

  useEffect(() => {
    if (document.getElementById("calendly-script")) { setCalendlyLoaded(true); return; }
    const s = document.createElement("script");
    s.id = "calendly-script";
    s.src = "https://assets.calendly.com/assets/external/widget.js";
    s.async = true;
    s.onload = () => setCalendlyLoaded(true);
    document.body.appendChild(s);
  }, []);

  return (
    <div className="min-h-screen bg-stone-50">
      <SEO title="Reserva tu Orientación · Confirmación de pago" path="/orientacion/reservar" noindex />
      <SiteHeader />

      {/* HERO + CONFIRMACIÓN */}
      <section className="bg-[#2d1f1a] text-white">
        <div className="max-w-5xl mx-auto px-6 py-16">
          <div className="inline-flex items-center gap-2 bg-emerald-500/15 border border-emerald-400/40 text-emerald-300 px-3 py-1 rounded-sm text-[10px] tracking-[0.25em] uppercase font-bold mb-5" data-testid="payment-confirmation-pill">
            ✓ Pago confirmado · 15 €
          </div>
          <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight leading-[1.05] mb-4">
            ¡Gracias! Ahora <span className="text-[#E0651F]">reserva tu videollamada</span>.
          </h1>
          <p className="text-stone-300 leading-relaxed max-w-3xl">
            Elige un hueco en el calendario que te venga bien. Recibirás el enlace de la videollamada por email tras confirmar la reserva.
          </p>
        </div>
      </section>

      {/* CALENDLY */}
      <section className="max-w-5xl mx-auto px-6 py-12">
        <div className="bg-white border border-stone-200 rounded-sm overflow-hidden shadow-sm" data-testid="calendly-embed">
          {calendlyLoaded ? (
            <div className="calendly-inline-widget" data-url={CALENDLY_URL} style={{ minWidth: "320px", height: "780px" }} />
          ) : (
            <div className="h-[780px] flex items-center justify-center text-stone-500 text-sm">Cargando calendario…</div>
          )}
        </div>
        <p className="text-center text-xs text-stone-500 mt-5">
          ¿Problemas con el calendario? Escríbenos por <a href={buildWaUrl(WA_MSG.orientacion)} target="_blank" rel="noopener noreferrer" onClick={(e) => { e.preventDefault(); openWhatsApp(WA_MSG.orientacion); }} className="text-[#E0651F] font-bold hover:underline">WhatsApp</a> o por <a href="mailto:fmsubastasinvestment@gmail.com" className="text-[#E0651F] font-bold hover:underline">email</a> y agendamos manualmente.
        </p>
      </section>

      {/* WHAT TO PREPARE */}
      <section className="bg-stone-100 py-14">
        <div className="max-w-3xl mx-auto px-6">
          <div className="text-[11px] tracking-[0.25em] uppercase font-bold text-[#E0651F] mb-3">Antes de la videollamada</div>
          <h2 className="font-display text-2xl sm:text-3xl font-black tracking-tight text-[#2d1f1a] mb-5 leading-tight">
            Llega con tus dudas reales. Sin presiones.
          </h2>
          <ul className="space-y-3 text-sm text-stone-700">
            <li className="flex gap-3"><Video className="w-5 h-5 text-[#E0651F] flex-shrink-0 mt-0.5" /><span>Conéctate desde un sitio tranquilo, con cámara y micro. 30 minutos es suficiente.</span></li>
            <li className="flex gap-3"><ArrowRight className="w-5 h-5 text-[#E0651F] flex-shrink-0 mt-0.5" /><span>Si tienes una subasta concreta en mente, tenla a mano (ID BOE, edicto, lo que sea).</span></li>
            <li className="flex gap-3"><ArrowRight className="w-5 h-5 text-[#E0651F] flex-shrink-0 mt-0.5" /><span>Apunta tus dudas: te las resolveremos una a una.</span></li>
          </ul>
          <div className="mt-8 flex flex-wrap gap-3">
            <a href={buildWaUrl(WA_MSG.orientacion)} target="_blank" rel="noopener noreferrer"
              onClick={(e) => { e.preventDefault(); openWhatsApp(WA_MSG.orientacion); }}
              className="inline-flex items-center gap-2 bg-[#2d1f1a] hover:bg-[#E0651F] text-white px-6 py-3 text-xs tracking-[0.18em] uppercase font-bold rounded-sm transition-colors"
              data-testid="reservar-whatsapp">
              <MessageCircle className="w-4 h-4" /> WhatsApp
            </a>
            <Link to="/" className="inline-flex items-center gap-2 text-[#E0651F] hover:underline px-2 py-3 text-xs tracking-[0.18em] uppercase font-bold">
              Volver al inicio <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}
